import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useMyprofileOutput } from '@/composables/format-edit/useMyprofileOutput'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyprofileOutputCard',
  props: {
    currentCardId: null,
    formatId: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
};



const getMode = computed(() => process.env.VUE_APP_MODE)

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const {
  savingImage,
  sharingImage,
  imageError,
  canShareImage,
  saveMyprofileImage,
  shareMyprofileImage
} = useMyprofileOutput()

return { __sfc: true,props, getMode, isSection, savingImage, sharingImage, imageError, canShareImage, saveMyprofileImage, shareMyprofileImage }
}

})